import dayjs from "dayjs";
import { useState } from "react";

const useTxnFilterHook = (initialValues) => {
  const [filters, setFilters] = useState({
    from:
      initialValues?.from ?? dayjs().subtract(7, "days").format("YYYY-MM-DD"),
    to: initialValues?.to ?? dayjs().add(1, "day").format("YYYY-MM-DD"),
    searchValue: "",
  });
  const [isFilter, setIsFilter] = useState({
    date: false,
    search: false,
  });

  return {
    filters,
    isFilter,
    setIsFilter,
    setFilters: (input) => {
      setFilters((p) => ({ ...p, ...input }));
    },
    resetFilters: (values) => {
      setFilters({
        from: values?.from || dayjs().subtract(7, "days").format("YYYY-MM-DD"),
        to: values?.to || dayjs().add(1, "day").format("YYYY-MM-DD"),
        searchValue: "",
      });
    },
  };
};

export default useTxnFilterHook;
